export const actionCopyDa = {
    next: "Næste",
    back: "Tilbage",
    save: "Gem",
    send: "Send",
    skip: "Spring over",
    skipForNow: "Jeg ved det ikke endnu",
    continue: "Fortsæt",
    cancel: "Annuller",
    delete: "Slet",
    submit: "Indsend",
    confirm: "Bekræft",
    add: "Tilføj",
    edit: "Rediger",
    done: "Færdig",
    stop: "Stop",
    retry: "Prøv igen",
    download: "Download",
    apply: "Anvend",
    filter: "Filter",
    filters: "Filtre",
    columns: "Kolonner",
    close: "Luk",
    search: "Søg",
    more: "Mere",
    none: "Ingen",
    previous: "Forrige",
    rename: "Omdøb",
    duplicate: "Dupliker",
    share: "Del",
    clearAll: "Ryd alle",
    clearSearch: "Ryd søgning",
    loading: "Indlæser...",
    open: "Åbn",
    invite: "Inviter",
    saveCorrection: "Gem rettelse",
    saving: "Gemmer...",
    sending: "Sender...",
    submitting: "Indsender...",
    skipping: "Springer over...",
    goingBack: "Går tilbage...",
    goingNext: "Går videre...",
    cancelling: "Annullerer...",
    deleting: "Sletter...",
    deleteConfirmTitle: "Er du helt sikker?",
    deleteConfirmDescription: "Denne handling kan ikke fortrydes.",
    continuing: "Fortsætter...",
    confirming: "Bekræfter...",
    adding: "Tilføjer...",
    editing: "Redigerer...",
    finishing: "Afslutter...",
    stopping: "Stopper...",
    retrying: "Prøver igen...",
    downloading: "Downloader...",
};
